import EnumSet from 'Services/enumSet'

interface IBillingStatus extends EnumSet {
  none: number
  chargedback: number
  refused: number
  authorized: number
  waitingPayment: number
  paid: number
  pendingRefund: number
  refunded: number
  processing: number
  pendingReview: number
  open: number
  cancelled: number
  boletoExpired: number
  analyzing: number
  chargeChargeback: number
  chargePaid: number
  chargePaymentFailed: number
  chargePending: number
  chargeProcessing: number
  chargeRefunded: number
}

const billingStatus = new EnumSet({
  none: { value: 0, description: 'Nenhum' },

  chargedback: { value: 1, description: 'Cobrar de volta' },
  refused: { value: 2, description: 'Recusado' },
  authorized: { value: 3, description: 'Autorizado' },
  waitingPayment: { value: 4, description: 'Aguardando pagamento' },
  paid: { value: 5, description: 'Pago' },
  pendingRefund: { value: 6, description: 'Pendente de estorno' },

  processing: { value: 8, description: 'Processando' },
  pendingReview: { value: 9, description: 'Revisão pendente' },
  refunded: { value: 10, description: 'Transação estornada completamente' },
  analyzing: { value: 11, description: 'Em análise antifraude' },

  // Status V5
  chargeChargeback: { value: 20, description: 'Cobrar de volta' },
  chargePaid: { value: 21, description: 'Pago' },
  chargePaymentFailed: { value: 22, description: 'Recusado' },
  chargePending: { value: 23, description: 'Pendente' },
  chargeProcessing: { value: 24, description: 'Processando' },
  chargeRefunded: { value: 25, description: 'Transação estornada completamente' },

  // Status do sistema
  open: { value: 30, description: 'Aberto' },
  cancelled: { value: 31, description: 'Cancelado' },
  boletoExpired: { value: 32, description: 'Boleto vencido' },
}) as IBillingStatus

export default billingStatus